import React from 'react';
import '../css/AboutProfileBlock.css';

const AboutProfileBlock = () => {
  return (
    <section className="gfi-profile-block-section">
      <div className="gfi-profile-block-container">
        
        {/* TWO COLUMN ASYMMETRIC GRID LAYER */}
        <div className="gfi-profile-mesh-grid">
          
          {/* LEFT COLUMN: TYPOGRAPHY CONTENT STRIPS */}
          <div className="gfi-profile-text-column">
            
            <div className="gfi-establishment-pill-tag">
              <span>ESTABLISHED SINCE 2010</span>
            </div>

            <h2 className="gfi-profile-block-title">
              Trusted Leader in <br />
              <span className="gfi-profile-highlight-blue">Safety Education</span>
            </h2>

            <div className="gfi-profile-paragraphs-stack">
              <p className="gfi-profile-para bold-lead">
                <strong>Greenfield Industrial Fire and Safety Academy</strong> is one of the trusted Fire & Safety and 
                Industrial Safety training institutes in Bihar, Uttar Pradesh, and India, offering practical, 
                industry-oriented, and career-focused education for students and working professionals.
              </p>

              <p className="gfi-profile-para">
                We provide Fire & Safety, Industrial Safety, NEBOSH, IOSH, HSE, Diploma, Degree, and E-Learning 
                programs designed to improve workplace safety awareness, practical skills, and employability across various industries.
              </p>

              <p className="gfi-profile-para location-highlight-strip">
                Our training services are available for students from <strong>Siwan, Chapra, Gopalganj, Ara, Muzaffarpur, 
                Patna, Kushinagar, Varanasi, Mau, Deoria</strong>, and nearby regions through classroom and online learning options.
              </p>

              <p className="gfi-profile-para">
                With experienced trainers, modern learning methods, practical training facilities, and placement support, 
                Greenfield Industrial Fire and Safety Academy is committed to helping students build successful careers in Health & Safety, 
                Industrial Safety, Fire Protection, Environmental Management, and related sectors.
              </p>
            </div>

            {/* TWO BUTTON CTA ROW ACTION GRID */}
            <div className="gfi-profile-action-row">
              <button className="gfi-btn gfi-btn-solid-blue">ENROLL TODAY</button>
              <button className="gfi-btn gfi-btn-outline-blue">VIEW COURSES</button>
            </div>

          </div>

          {/* RIGHT COLUMN: REINFORCED MULTI-LAYER COMPOSITE MEDIA FRAME */}
          <div className="gfi-profile-media-column">
            <div className="gfi-media-frame-canvas">
              
              {/* Top-Right Absolute Backdrop Dot Array */}
              <div className="gfi-media-decorative-dots"></div>

              {/* Main Industry Fire Extinguisher Drill Mock Presentation Image */}
              <img 
                src="https://images.unsplash.com/photo-1618090584176-7132b9911657?q=80&w=600&auto=format&fit=crop" 
                alt="Greenfield Safety Academy Practical Mock Fire Drills Live Operations Session" 
                className="gfi-main-campus-snapshot-img"
              />

              {/* Floating Bottom Left Layer Overlapping Quality Assurance Box */}
              <div className="gfi-iso-certification-floating-badge">
                <div className="gfi-iso-badge-icon-core">
                  {/* Styled Gear/Star Certificate Seal Indicator Vector */}
                  <div className="gfi-star-seal-svg">★</div>
                </div>
                <div className="gfi-iso-badge-text-matrix">
                  <h4 className="gfi-iso-main-code-title">ISO 9001:2015</h4>
                  <p className="gfi-iso-sub-quality-caption">QUALITY CERTIFIED</p>
                </div>
              </div>

            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default AboutProfileBlock;